<template>
  <v-card outlined class="ma-2" elevation="2">
    <v-card-title class="text-h5 title-header"
      >{{ $t("llm_config.ai_config.title") }}
    </v-card-title>
    <v-card-text>
      <v-row justify="center" align="center">
        <v-col cols="12">
          <v-row justify="start" dense>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="question_counter"
                :label="$t('llm_config.ai_config.question_counter_label')"
                :placeholder="
                  $t('llm_config.ai_config.question_counter_placeholder')
                "
                type="number"
                :rules="form_roles.number"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="numberOfCache"
                :label="
                  $t('llm_config.ai_config.cache_number_of_questions_label')
                "
                :placeholder="
                  $t(
                    'llm_config.ai_config.cache_number_of_questions_placeholder'
                  )
                "
                type="number"
                :rules="form_roles.number"
                outlined
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-card outlined>
                <v-card-title>
                  {{ $t("llm_config.ai_config.is_llm_knowledge.name") }}
                </v-card-title>
                <v-card-subtitle
                  v-html="$t('llm_config.ai_config.is_llm_knowledge.hint')"
                >
                </v-card-subtitle>
                <v-card-text>
                  <v-switch
                    class="my-0 py-0"
                    v-model="is_llm_knowledge"
                    :rules="form_roles.booleanField"
                    hide-details
                  ></v-switch>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "AIConfig",
  components: {},
  data: () => ({
    show1: false,
  }),
  props: {
    openaiConfig: {
      type: Object,
      required: true,
    },
    form_roles: {
      type: Object,
      required: true,
    },
  },
  created() {
    const defaults = {
      is_llm_knowledge: false,
    };
    Object.keys(defaults).forEach((key) => {
      if (!(key in this.openaiConfig.langchain_settings)) {
        this.$set(this.openaiConfig.langchain_settings, key, defaults[key]);
      }
    });
  },
  computed: {
    question_counter: {
      get() {
        return this.openaiConfig.question_counter || 0;
      },
      set(value) {
        value = Number(value);
        this.$set(this.openaiConfig, "question_counter", value);
      },
    },
    numberOfCache: {
      get() {
        return this.openaiConfig.langchain_settings?.numberOfCache || 0;
      },
      set(value) {
        value = Number(value);
        this.$set(this.openaiConfig.langchain_settings, "numberOfCache", value);
      },
    },
    is_llm_knowledge: {
      get() {
        return this.openaiConfig.langchain_settings.is_llm_knowledge || false;
      },
      set(value) {
        this.$set(
          this.openaiConfig.langchain_settings,
          "is_llm_knowledge",
          value
        );
      },
    },
  },
};
</script>

<style scoped>
.title-header {
  font-weight: bold;
  color: #1141ce !important;
}
</style>
